import { useMemo } from 'react';
import { useRouter } from 'next/router';

export const FEATURES = {
    PB_THUMBNAILS: 'PB_THUMBNAILS',
};

/**
 * Parses the `feature` query string (CSV, e.g. `feature=PB_THUMBNAILS,OTHER`)
 * into a set of enabled feature flags.
 *
 * @returns {Set<string>}
 */
export const useFeatures = () => {
    const {
        query: { feature },
    } = useRouter();

    const key = [].concat(feature ?? []).join(',');

    return useMemo(
        () =>
            new Set(
                key
                    .split(',')
                    .map((value) => value.trim())
                    .filter(Boolean)
            ),
        [key]
    );
};
